import { UserDiseaseHistoryModel } from './userDiseaseHistoryModel';
import { UserMedicineHistoryModel } from './userMedicineHistoryModel';

export class UserPrescriptionModel {
  public userPrescriptionId: number;
  public userId: number;
  public startDate?: string;
  public endDate?: string;
  public prescription: string;
  public doctor: string;
  public hospital: string;
  public comments: string;
  public notAllowedFoods: string;
  public recommendedFoods: string;
  public recommendedTreatment: string;
  public isActive: boolean;
  public userMedicines: Array<UserMedicineHistoryModel>;
  public userDiseases: Array<UserDiseaseHistoryModel>;
}